import type { ActiveOrder, BranchSummary } from "@/types";

export const currentStore = {
  brandName: "مطعم البيت السعودي",
  ownerName: "عبدالله المطيري",
  logo: "https://readdy.ai/api/search-image?query=Simple%20flat%20logo%20of%20a%20traditional%20Saudi%20restaurant%20with%20a%20golden%20dish%20icon%20on%20a%20clean%20white%20background%2C%20minimal%20vector%20style%2C%20emerald%20green%20and%20golden%20yellow%20accents&width=200&height=200&seq=yc-store-logo-01&orientation=squarish",
  status: "active" as const,
  statusLabel: "نشط",
  rating: 4.3,
  ratingCount: 312,
};

export const dashboardStats = {
  todayOrders: 128,
  todaySales: 8420.5,
  activeOrders: 7,
  cashEnabled: true,
  cashDebt: 384,
};

export const dashboardTrends = {
  orders: { value: 12, direction: "up" as const, suffix: "%" },
  sales: { value: 8.5, direction: "up" as const, suffix: "%" },
  activeOrders: {
    value: 5,
    direction: "down" as const,
    suffix: "%",
    tone: "neutral" as const,
  },
  rating: { value: 0.2, direction: "up" as const, suffix: "" },
};

export const branchesSummary: BranchSummary[] = [
  { id: "b1", name: "فرع العليا", isOpen: true, isActive: true },
  { id: "b2", name: "فرع النخيل", isOpen: true, isActive: true },
  { id: "b3", name: "فرع الملقا", isOpen: false, isActive: true },
  { id: "b4", name: "فرع الحمراء", isOpen: false, isActive: false },
];

export const activeOrdersList: ActiveOrder[] = [
  {
    id: "1054",
    branch: "فرع العليا",
    customer: "سعد الحربي",
    timeAgo: "منذ 3 دقائق",
    items: 4,
    amount: 113.8,
    status: "new",
    pickup: "car",
    payment: "card",
    source: "app",
  },
  {
    id: "1053",
    branch: "فرع النخيل",
    customer: "نورة القحطاني",
    timeAgo: "منذ 6 دقائق",
    items: 2,
    amount: 69,
    status: "preparing",
    pickup: "branch",
    payment: "applepay",
    source: "app",
  },
  {
    id: "1052",
    branch: "فرع العليا",
    customer: "فهد الدوسري",
    timeAgo: "منذ 9 دقائق",
    items: 6,
    amount: 217.75,
    status: "almost",
    pickup: "local",
    payment: "wallet",
    source: "app",
  },
  {
    id: "1051",
    branch: "فرع الملقا",
    customer: "ريم العتيبي",
    timeAgo: "منذ 12 دقيقة",
    items: 3,
    amount: 96,
    status: "ready",
    pickup: "car",
    payment: "cash",
    source: "branch",
  },
  {
    id: "1050",
    branch: "فرع النخيل",
    customer: "خالد الشهري",
    timeAgo: "منذ 15 دقيقة",
    items: 5,
    amount: 179.25,
    status: "preparing",
    pickup: "branch",
    payment: "card",
    source: "app",
  },
  {
    id: "1049",
    branch: "فرع العليا",
    customer: "منى الغامدي",
    timeAgo: "منذ 18 دقيقة",
    items: 1,
    amount: 37,
    status: "new",
    pickup: "local",
    payment: "applepay",
    source: "app",
  },
  {
    id: "1048",
    branch: "فرع الملقا",
    customer: "أحمد الزهراني",
    timeAgo: "منذ 22 دقيقة",
    items: 8,
    amount: 310.5,
    status: "ready",
    pickup: "car",
    payment: "wallet",
    source: "app",
  },
];